import './_filter.scss';
import './_filter.dark-mode.scss';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import qs from 'qs';
import $ from 'jquery';

import DropdownSubMenu from './dropdownSubMenu';
import DropdownCalendar from './dropdownCalendar';

import { getActiveStatus, getActiveAssign } from './helpers';
import {
  COPY_ALL_COLUMN_DATA,
  COPY_ALL_COLUMN_DATA_WITH_PROVIDER,
  COPY_EXTERNAL_ID,
  COPY_LINK,
  COPY_ORDER_ID,
} from '../../../pages/Orders/constants';

const Dropdown = ({
  size,
  title,
  dropStyle,
  classForBtnDrop,
  items,
  forMassActions,
  toolbarClass,
  handleSelect,
  item,
  disabled,
  forAssign,
  disableIndicator,
  submenuStatuses,
  submenuPlacement,
  queryRequest,
  simple,
  buttonId,
  dropUp,
  pullRight,
  showItemHeader,
  itemHeaderTitle,
  configAccess = {
    see_order_id: true,
    see_external_id: true,
    see_link: true,
    see_all_data: true,
  },
  dispatchAction,
  isLoading,
}) => {
  const location = useLocation();
  const queryString = qs.parse(location.search.slice(1));

  const [firstRender, setFirstRender] = useState(true);
  const [showDrop, setShowDrop] = useState(false);
  const [subDropdownsOpen, setDropdownsOpen] = useState([false, false, false, false]);

  const toggle = (index) => {
    if (index === 2) {
      if (subDropdownsOpen[index]) {
        $('#datePicker').data('daterangepicker').hide();
      } else {
        $('#datePicker').data('daterangepicker').show();
      }
    }

    setDropdownsOpen((prevState) => prevState.map((item, idx) => (idx === index ? !item : item)));

    if (index === 3) {
      setShowDrop(false);
    }
  };

  const onMouseEnter = (index) => {
    if (index === 2) {
      $('#datePicker').data('daterangepicker').show();
    }

    setDropdownsOpen((prevState) => prevState.map((item, idx) => (idx === index ? true : item)));
  };

  const onMouseLeave = (index) => {
    if (index === 2) {
      $('#datePicker').data('daterangepicker').hide();
    }

    setDropdownsOpen((prevState) => prevState.map((item, idx) => (idx === index ? false : item)));
  };

  const onSelect = (key, el, date) => {
    if (handleSelect) {
      if (item) {
        return handleSelect(key, el.title, item);
      }
      handleSelect(key, el.title, date);
    }
  };

  const prepareCopyClipSub = (access) => {
    const subItems = [
      access?.see_order_id && { id: COPY_ORDER_ID, title: 'Order ID' },
      access?.see_external_id && { id: COPY_EXTERNAL_ID, title: 'External ID' },
      access?.see_link && { id: COPY_LINK, title: 'Link' },
      access?.see_all_data && { id: COPY_ALL_COLUMN_DATA, title: 'All column data' },
      access?.see_all_data_with_provider && { id: COPY_ALL_COLUMN_DATA_WITH_PROVIDER, title: 'All column data with provider' },
    ];

    return subItems.filter(Boolean);
  };

  useEffect(() => {
    if (showDrop && firstRender) {
      setFirstRender(false);
      dispatchAction && dispatchAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDrop]);

  return (
    <ButtonToolbar className={`${toolbarClass}`}>
      <DropdownButton
        onToggle={setShowDrop}
        open={showDrop}
        bsSize={size}
        title={title}
        bsStyle={dropStyle}
        id={buttonId ? `${buttonId}` : `dropdown-size-${size || 'medium'}`}
        className={`${classForBtnDrop}${isLoading ? ' dropdown-action-loading' : ''}`}
        disabled={disabled}
        dropup={dropUp}
        pullRight={pullRight}
      >
        {showItemHeader && <MenuItem header>{itemHeaderTitle}</MenuItem>}

        {items?.map((el, i) => {
          if (el.title === 'Change status') {
            return (
              <DropdownSubMenu
                key={`Status${el.id}`}
                handleSelect={handleSelect}
                element={el}
                toggle={() => toggle(0)}
                dropdownOpen={subDropdownsOpen[0]}
                onMouseEnter={() => onMouseEnter(0)}
                onMouseLeave={() => onMouseLeave(0)}
                submenuStatuses={submenuStatuses}
                submenuPlacement={submenuPlacement}
              />
            );
          }

          if (el.title === 'Assign') {
            return (
              <DropdownSubMenu
                key={`Assign${el.id}`}
                handleSelect={handleSelect}
                element={el}
                toggle={() => toggle(1)}
                dropdownOpen={subDropdownsOpen[1]}
                onMouseEnter={() => onMouseEnter(1)}
                onMouseLeave={() => onMouseLeave(1)}
                forAssign
              />
            );
          }

          if (el.title === 'Sort by') {
            return (
              <DropdownSubMenu
                key={`sort_by_${el.id}`}
                handleSelect={handleSelect}
                element={el}
                toggle={() => toggle(1)}
                dropdownOpen={subDropdownsOpen[1]}
                onMouseEnter={() => onMouseEnter(1)}
                onMouseLeave={() => onMouseLeave(1)}
                forAssign
              />
            );
          }

          if (el.title === 'Custom range') {
            return (
              <DropdownCalendar
                key={`Calendar${el.id}`}
                handleSelect={handleSelect}
                element={el}
                toggle={() => toggle(2)}
                dropdownOpen={subDropdownsOpen[2]}
                onMouseEnter={() => onMouseEnter(2)}
                submenuPlacement={submenuPlacement}
                setShowDrop={setShowDrop}
              />
            );
          }

          if (el.title === 'Copy to clipboard') {
            return (
              <DropdownSubMenu
                key={`Status${el.id}`}
                handleSelect={handleSelect}
                element={el}
                toggle={() => toggle(3)}
                dropdownOpen={subDropdownsOpen[3]}
                onMouseEnter={() => onMouseEnter(3)}
                onMouseLeave={() => onMouseLeave(3)}
                submenuStatuses={prepareCopyClipSub(configAccess)}
                submenuPlacement={submenuPlacement}
              />
            );
          }

          return (
            <MenuItem
              key={i}
              eventKey={el.code ?? el.id}
              active={
                simple
                  ? title === el.title
                  : forMassActions || disableIndicator
                    ? null
                    : forAssign
                      ? getActiveAssign(queryString, location.pathname) === +el.id
                      : getActiveStatus(queryString, location.pathname, queryRequest) === el.id
              }
              onSelect={(key) => onSelect(key, el)}
            >
              {el.title}
              {el?.count >= 0 && ` (${el.count})`}
            </MenuItem>
          );
        })}
      </DropdownButton>
    </ButtonToolbar>
  );
};

Dropdown.propTypes = {
  size: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dropStyle: PropTypes.string,
  classForBtnDrop: PropTypes.string,
  items: PropTypes.array,
  toolbarClass: PropTypes.string,
  handleSelect: PropTypes.func,
  disabled: PropTypes.bool,
  forAssign: PropTypes.bool,
  disableIndicator: PropTypes.bool,
  submenuStatuses: PropTypes.array,
  submenuPlacement: PropTypes.string,
  queryRequest: PropTypes.string,
  forMassActions: PropTypes.bool,
  item: PropTypes.object,
  simple: PropTypes.bool,
  dropUp: PropTypes.bool,
  buttonId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  pullRight: PropTypes.bool,
  showItemHeader: PropTypes.bool,
  itemHeaderTitle: PropTypes.string,
  configAccess: PropTypes.object,
  dispatchAction: PropTypes.func,
  isLoading: PropTypes.bool,
};

Dropdown.defaultProps = {
  title: 'default',
  dropStyle: 'default',
  dropUp: false,
  classForBtnDrop: 'custom__filter-dropdown--button',
  items: [],
  pullRight: true,
};

export default Dropdown;
